/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import {I18n, Translate} from 'react-redux-i18n';
import SwipeableViews from 'react-swipeable-views';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import ScrollEvent from '@peoplenet/vi-common-util/src/Form/ScrollEvent';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import querystring from 'querystring';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Tooltip from '@material-ui/core/Tooltip';
import InputAdornment from '@material-ui/core/InputAdornment';
import {filter, toLower, each, padStart, get, cloneDeep} from 'lodash';
import CircularProgress from '@material-ui/core/CircularProgress';
import AutoCompleteInput from '../../Form/AutoCompleteInput';

import moment, { DATETIME_FORMAT_IN_ISO, TIME_FORMAT_IN_ISO } from '../../util/moment';
import PreviouslyQueue from '../component/PreviouslyQueue';
import ChannelsAvailable from '../component/ChannelsAvailable'; // eslint-disable-line import/no-named-as-default
import CameraViews from '../component/CameraViews';
import ProgressSpinner from '../../components/ProgressSpinner';
import {MACHINE_TYPE} from '../../app/configuration/cameras';
import {VEHICLE_ONDEMAND_KEY} from '../../app/configuration/localstorageKeys';
import {popQueryParameter, VEHICLE_NUMBER_KEY} from '../../app/historyUtil';
import DesktopOnDemandFilter from '../../NewLibraryFilter/component/DesktopOnDemandFilter';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import TextField from '@mui/material/TextField';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { MAX_DURATION_MIN } from '../onDemandConstants';
import BlurringSettings from './../component/BlurringSettings';
import hasAccess from './../../app/user';
function TabContainer(props) {
  return <div>{props.children}</div>;
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

const systemId = localStorage.getItem('systemId') || '';

const initialState = {
  step: 1,
  tabIndex: 0,
  vehicleInvalid: false,
  dvrInvalid: false,
  vehicle: null,
  dvr: null,
  cameras: [],
  startDate: null,
  startDateTime: moment(),
  startTime: null,
  endDateTime: moment(),
  duration: null,
  durationTotal: null,
  durationNotFound: false,
  durationInvalid: false,
  durationInFuture: false,
  camerasInvalid: false,
  dvrScanIntervals: [],
  dvrScanTimeLabels: [],
  dvrScanStatus: false,
  dvrScanRequested: {},
  submitDisabled: true,
  autocompleteValue: '',
  serialAutocompleteValue: '',
  camerasTotalSize: 0,
  pairingMethod: 'dsn',
  workflow: 'vehicle',
  onDemandFilter: {
    vehicleValue: '',
    whoRequestedValue: '',
    cameraViewValue: [],
    statusValue: [],
  },
  dateError: '',
  starTimeError: '',
  durationError: '',
  blurringField: {show: false, disabled: false, value: false},
  totalAdPlusDvrs: 0
};

const blankState = {
  startDate: undefined,
  startTime: undefined,
  duration: null,
  cameras: [],
}

class DesktopOnDemand extends React.Component {
  constructor(props) {
    super(props);

    initialState.pairingMethod = get(props.customer, 'data.dvrPairing.method', 'dsn');
    initialState.workflow = get(props.customer, 'data.onDemand.workflow', 'vehicle');
    
    //Blurring settings
    const blurring = get(props.customer, 'data.blurring_v2', {});
    const systemBlurringSettings = get(props.systemSettings, 'blurring', false);
    const canModifyBlurringOpt = hasAccess([
      'videoIntelligenceAdmin'
    ]);
    let showBlurringField = true;
    let blurringVal = blurring.enabled;
    let blurringDisabled = false;
    if (systemBlurringSettings === false && (!blurring.hasOwnProperty('enabled') || blurring.enabled === false)) {
      showBlurringField = false;
    } else if (systemBlurringSettings === false && blurring.enabled === true) {
      showBlurringField = true;
      blurringDisabled = canModifyBlurringOpt ? false : true;
    } else if (systemBlurringSettings === true && (!blurring.hasOwnProperty('enabled') || blurring.enabled === true)) {
      showBlurringField = true;
      blurringDisabled = canModifyBlurringOpt ? false : true;
      blurringVal = true;
    }
    initialState.blurringField = {show: showBlurringField, disabled: blurringDisabled, value: blurringVal};

    this.state = initialState;

    const vehicleNumber = popQueryParameter(VEHICLE_NUMBER_KEY);
    const addinVehicleNumber = localStorage.getItem('vehicleOnDemandAddin');

    if (vehicleNumber) {
      localStorage.setItem(VEHICLE_ONDEMAND_KEY, vehicleNumber);
    } else if (systemId && systemId === 'geotab' && addinVehicleNumber) {
      localStorage.setItem(VEHICLE_ONDEMAND_KEY, addinVehicleNumber);
    }
  }

  componentDidMount = () => {
    this.props.loadTotalRequested();
    this.props.loadQueueList({page: 0});
    this.props.getSettings(true);
    this.setVehicleByQuery();
  }

  componentWillReceiveProps = nextProps => {
    this.updateScanIntervals(nextProps);
  }

  componentDidUpdate = () => {
    const {requestQueue} = this.props;
    const isQueueTab = (this.state.tabIndex === 0);
    let height = window.innerHeight;
    let innerH = systemId === 'geotab' ? document.getElementById('root').clientHeight : document.body.clientHeight;

    if (height > innerH &&
      isQueueTab &&
      !requestQueue.isLoading &&
      requestQueue.list.length > 0 &&
      (requestQueue.page + 1 < requestQueue.pages)) {
      this.props.loadQueueList({page: requestQueue.page + 1});
    }
    this.state.totalAdPlusDvrs = this.props.totalAdPlusDvrs;
  }

  componentWillUnmount() {
    localStorage.removeItem(VEHICLE_ONDEMAND_KEY);
    this.props.reset();
    this.props.clearTables();
  }

  handleOnDemandFilter = value => {
    this.setState({
      onDemandFilter: {
        vehicleValue: value.vehicle,
        whoRequestedValue: value.whoRequested,
        cameraViewValue: value.cameraView,
        statusValue: value.status
      }
    }, () => {
      if (value.tabIndex === 0) {
        this.props.loadQueueList({
          page: 0,
          vehicleNumber: this.state.onDemandFilter.vehicleValue,
          userNameRequested: this.state.onDemandFilter.whoRequestedValue,
          channels: this.state.onDemandFilter.cameraViewValue,
          status: this.state.onDemandFilter.statusValue,
        });
      } else {
        const {previouslyRequestedQueue: {sort, sortOrder}} = this.props;
        this.props.loadPreviouslyQueueList({
          page: 0,
          sort: sort,
          sortOrder: sortOrder,
          vehicleNumber: this.state.onDemandFilter.vehicleValue,
          userNameRequested: this.state.onDemandFilter.whoRequestedValue,
          channels: this.state.onDemandFilter.cameraViewValue,
          status: this.state.onDemandFilter.statusValue,
        });
      } 
    });
  }

  setVehicleByQuery = () => {
    const vehicleNumber = localStorage.getItem(VEHICLE_ONDEMAND_KEY);
    if (vehicleNumber) {
      if (initialState.workflow === 'dvr') {
        this.props.searchDVRs({text: vehicleNumber}).then(dvrs => {
          const name = get(dvrs, '[0].name', null);
          const serial = get(dvrs, '[0].serial', null);
          if (name && serial) {
            this.setState({serialAutocompleteValue: name}, () => {
              this.handleOnSelectedDvrAutocomplete(null, {suggestion: {name, serial, type: 'dvr'}});
            });
          }
        });
      } else {
        const suggestion = {serial: vehicleNumber, name: vehicleNumber, type: 'vehicle'};
        this.setState({autocompleteValue: vehicleNumber}, () => {
          this.handleOnSelectedAutocomplete(null, {suggestion});
        });
      }
    }
  }

  getScanIntervalWidth = (start, end) => {
    const diff = moment.duration(moment(end).diff(moment(start))).asMilliseconds();
    return (diff * 100) / 43200000;
  }

  getDurationTotal = (startDateTime, endDateTime) => {
    const totalSeconds = (endDateTime.diff(startDateTime, 's') * this.state.camerasTotalSize);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds - (minutes * 60);
    return `${padStart(minutes, 2, 0)}:${padStart(seconds, 2, 0)}`;
  }

  getUsername = item => {
    return ((item.metadata && item.metadata.userNameRequested) || item.userId || item.uid);
  }

  resetToBlankForm = () => {
    localStorage.removeItem(VEHICLE_ONDEMAND_KEY);
    this.props.reset();
    this.props.loadTotalRequested();
    this.setState({...initialState, ...blankState}, this.setVehicleByQuery);
  }

  resetKeepingRequestParams = () => {
    const { startDate, startTime, duration } = this.state;
    this.props.reset();
    this.props.loadTotalRequested();
    this.setVehicleByQuery();
    this.setState({ ...initialState, ...{ startDate, startTime, duration } }, this.setVehicleByQuery);
  }

  fetchTimer = null;
  handleOnFetchAutocomplete = value => {
    if (this.fetchTimer) {
      window.clearTimeout(this.fetchTimer);
    }

    this.fetchTimer = window.setTimeout(() => {
      this.props.searchVehicles({text: value});
      this.fetchTimer = null;
    }, 550);
  }

  handleOnFetchDvrAutocomplete = value => {
    if (this.fetchTimer) {
      window.clearTimeout(this.fetchTimer);
    }
    this.fetchTimer = window.setTimeout(() => {
      this.props.searchDVRs({text: value});
      this.fetchTimer = null;
    }, 550);
  }

  handleOnSelectedAutocomplete = (event, {suggestion}) => {
    this.setState({
      vehicle: suggestion,
      vehicleInvalid: false,
      cameras: []
    }, this.validateForm);
    this.props.loadChannels({vehicle: {...suggestion}});
    localStorage.setItem(VEHICLE_ONDEMAND_KEY, suggestion.name);
  }

  handleOnSelectedDvrAutocomplete = (event, {suggestion}) => {
    this.setState({
      dvr: suggestion,
      dvrInvalid: false,
      cameras: []
    }, this.validateForm);
    this.props.loadChannels({dvr: {...suggestion}});
    localStorage.setItem(VEHICLE_ONDEMAND_KEY, suggestion.name);
  }

  handleOnChangeCamera = _cameras => {
    //const {cameras} = this.state;
    //cameras[MACHINE_TYPE.get(this.props.machineType)] = _cameras;
    this.setState({cameras: _cameras}, this.validateForm);
  }

  handleChangeWifi = event => {
    this.props.changeWifiCheckbox(event.target.checked);
  }

  handleOnBlurAutocomplete = event => {
    if (typeof event.target.value !== 'undefined') {
      this.props.clearChannels();
      this.setState({
        vehicleInvalid: true,
        dvrInvalid: true,
        dvr: null,
        vehicle: null
      });
    }
  }

  handleOnChangeDate = date => {
    this.setState({
      startDate: date
    }, this.validateForm);
  }

  handleOnChangeStartTime = time => {
    this.setState({
      startTime: time
    }, this.validateForm);
  }

  handleOnChangeDuration = duration => {
    this.setState({
      duration: duration
    }, this.validateForm);
  }

  handleGoToLibrary = () => {
    if (systemId && systemId === 'geotab') {
      this.props.history.push(`/library`);
    } else {
      this.props.goToLibrary();
    }
  }
  handleOnChangeBlurring = blurring => {
    const prevState = {...this.state.blurringField};
    prevState.value = blurring;
    this.setState({blurringField: prevState}, this.validateForm);
  }
  handleOnSubmit = () => {
    const {
      vehicle,
      dvr,
      cameras,
      startDate,
      startTime,
      duration,
      tabIndex,
      pairingMethod,
      blurringField
    } = this.state;
    const {
      machineType,
      vehicle: vehicleNumber,
      user: {
        userInformation: {
          userName: requestedBy
        }
      },
      wifiEnabled,
      customer
    } = this.props;
    const channels = cameras?.map((camera) => camera.channelIndex);
    //let i = 1;
    // each(cameras[MACHINE_TYPE.get(machineType)], c => {
    //   if (c) {
    //     channels.push(i);
    //   }
    //   i++; // eslint-disable-line no-plusplus
    // });

    const startDateStr = startDate.format('YYYY-MM-DD');
    const startTimeStr = startTime.format('HH:mm:ss');
    const startDateTime = moment(`${startDateStr} ${startTimeStr}`);
    const durationStr = duration.format('mm:ss');
    const durationArr = durationStr.split(':');
    const minutes = parseInt(durationArr[0], 10);
    const seconds = parseInt(durationArr[1], 10);
    const customerWifi = get(customer, 'data.onDemand.wifi.enabled', false);
    const params = {
      vehicleNumber: dvr ? vehicleNumber : vehicle.name,
      startDate: moment(startDateTime).toDate().getTime(),
      endDate: moment(startDateTime).add({minutes, seconds}).toDate().getTime(),
      channels: channels,
      machineType,
      wifi: wifiEnabled && customerWifi,
      pairingMethod,
      requestedBy
    };
    if (blurringField.show) {
      params.blurring = blurringField.value;
    }
    if (dvr) {
      params.serialNo = dvr.serial;
    }
    this.props.postFetchAsync(params);
    if (tabIndex === 0) {
      setTimeout(() => {
        this.props.loadQueueList({page: 0});
      }, 2000);
    }
  }

  handleOnCheckAvailability = () => {
    const {
      vehicle,
      dvr,
      workflow,
      startDate,
      startTime,
      duration,
      pairingMethod
    } = this.state;

    const startDateStr = startDate.format('YYYY-MM-DD');
    const startTimeStr = startTime.format('HH:mm:ss');
    const startDateTime = moment(`${startDateStr} ${startTimeStr}`);
    const durationStr = duration.format('mm:ss');
    const durationArr = durationStr.split(':');
    const minutes = parseInt(durationArr[0], 10);
    const seconds = parseInt(durationArr[1], 10);

    const params = {
      pairingMethod,
      startDate: moment(startDateTime).toDate().getTime(),
      endDate: moment(startDateTime).add({minutes, seconds}).toDate().getTime()
    };
    if (workflow === 'vehicle') {
      params.truckNumber = vehicle.name;
    }

    if (workflow === 'dvr') {
      params.serial = dvr.serial;
    }
    this.props.scanVideoAvailable(params);
  }

  handleOnClear = () => {
    localStorage.removeItem(VEHICLE_ONDEMAND_KEY);
    this.props.reset();
    this.setState({...initialState, ...blankState});
  }

  handleOnConfirmation = () => {
    const {
      startDate,
      startTime,
      duration
    } = this.state;

    const startDateStr = startDate.format('YYYY-MM-DD');
    const startTimeStr = startTime.format('HH:mm:ss');
    const startDateTime = moment(`${startDateStr} ${startTimeStr}`);
    const durationStr = duration.format('mm:ss');
    const durationArr = durationStr.split(':');
    const minutes = parseInt(durationArr[0], 10);
    const seconds = parseInt(durationArr[1], 10);
    const endDateTime = moment(startDateTime).add({minutes, seconds});

    const durationTotal = this.getDurationTotal(startDateTime, endDateTime);
    this.setState({
      step: 2,
      startDateTime,
      endDateTime,
      durationTotal
    });
  }

  handleOnCancel = () => {
    this.setState({step: 1});
  }

  handleAutocompleteChange = (event, {newValue}) => {
    this.setState({autocompleteValue: newValue});
  }

  handleSerialAutocompleteChange = (event, {newValue}) => {
    this.setState({serialAutocompleteValue: newValue});
  }

  handleChangeTab = (event, value) => {
    this.setState({tabIndex: value});

    if (value === 0) {
      this.props.loadQueueList({page: 0});
    } else {
      const {previouslyRequestedQueue: {sort, sortOrder}} = this.props;
      this.props.loadPreviouslyQueueList({page: 0, sort, sortOrder});
    }
  }

  handleChangeTabIndex = index => {
    this.setState({tabIndex: index});
  }

  handleLazyLoading = () => {
    const {requestQueue} = this.props;
    const isQueueTab = (this.state.tabIndex === 0);
    if (isQueueTab && !requestQueue.isLoading && requestQueue.hasMorePages) {
      const h = document.documentElement;
      const b = document.body;
      const st = 'scrollTop';
      const sh = 'scrollHeight';
      const percent = ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      if (percent > 80) {
        this.props.loadQueueList({page: requestQueue.page + 1});
      }
    }
  }

  handleLazyLoadingGeotab = () => {
    const {previouslyRequestedQueue, isEnabled} = this.props;
    if (isEnabled && !previouslyRequestedQueue.isLoading && previouslyRequestedQueue.hasMorePages) {
      const h = document.getElementById('root').parentElement;
      const b = document.getElementById('root');
      const st = 'scrollTop';
      const sh = 'scrollHeight';
      const percent = ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      if (percent > 80) {
        this.props.loadPreviouslyQueueList({
          page: previouslyRequestedQueue.page + 1,
          sort: previouslyRequestedQueue.sort,
          sortOrder: previouslyRequestedQueue.sortOrder
        });
      }
    }
  }

  handleCancelMedia = media => () => {
    this.props.cancelOndemandMedia(media);
  }

  handleSortTable = sort => () => {
    const {previouslyRequestedQueue: queue} = this.props;
    const sortOrder = (queue.sort === sort && queue.sortOrder === 'desc') ? 'asc' : 'desc';

    this.props.loadPreviouslyQueueList({page: 0, sort, sortOrder,
      vehicleNumber: this.state.onDemandFilter.vehicleValue,
      userNameRequested: this.state.onDemandFilter.whoRequestedValue,
      channels: this.state.onDemandFilter.cameraViewValue,
      status: this.state.onDemandFilter.statusValue,
    });
  }

  validateTime = () => {
    const {startDate, startTime, duration} = this.state;

    let durationNotFound = true;
    let minutes, seconds;
    if (!!duration) {
      const durationStr = duration.format('mm:ss');
      const durationArr = durationStr.split(':');
      minutes = parseInt(durationArr[0], 10);
      seconds = parseInt(durationArr[1], 10);

      durationNotFound = (!Number.isInteger(minutes) || !Number.isInteger(seconds));
      if (!durationNotFound) {
        durationNotFound = (minutes <= 0 && seconds <= 0);
      }
    }

    let durationInvalid = false;
    if (!durationNotFound) {
      durationInvalid = (minutes > 30) || (minutes === 30 && seconds > 0);
    }

    let durationInFuture = false;
    if (!!startDate && !!startTime && !!duration) {
      const startDateStr = startDate.format('YYYY-MM-DD');
      const startTimeStr = startTime.format('HH:mm:ss');
      durationInFuture = !durationInvalid && moment(`${startDateStr} ${startTimeStr}`, 'YYYY-MM-DD HH:mm:ss').add({minutes, seconds}).isAfter(moment());
    }

    this.setState({durationNotFound, durationInvalid, durationInFuture});

    return !durationNotFound && !durationInvalid && !durationInFuture && !!startDate && !!startTime;
  }

  validateForm = () => {
    const invalidDateTimeDuration = !this.validateTime();
    const {
      vehicle,
      dvr,
      workflow,
      cameras,
      dateError,
      starTimeError
    } = this.state;
    const camerasTotalSize = cameras?.length || 0;
    // const camerasTotalSize = filter(cameras[MACHINE_TYPE.get(this.props.machineType)], c => {
    //   return c;
    // }).length;
    const camerasCheckeds = camerasTotalSize > 0;
    const submitDisabled =
      workflow === 'dvr'
        ? dvr == null || !camerasCheckeds || invalidDateTimeDuration || !!dateError || !!starTimeError
        : vehicle == null || !camerasCheckeds || invalidDateTimeDuration || !!dateError || !!starTimeError;

    this.setState({
      camerasTotalSize,
      submitDisabled
    }, this.render);
  }

  updateScanIntervals = props => {
    const dvrScanTimeLabels = [];
    const requestedTime = get(props, 'dvrScanRequested.start', false);

    if (props.dvrScanErrorMessage) {
      return;
    }

    if (requestedTime) {
      // labels
      const time = moment(requestedTime);
      const format = TIME_FORMAT_IN_ISO;
      dvrScanTimeLabels.push(time.format(format));
      for (let i = 0; i < 12; i++) {
        dvrScanTimeLabels.push(time.add(1, 'hour').format(format));
      }
    }

    if (props.dvrScanIntervals.length > 0) {
      const dvrScanIntervals = props.dvrScanIntervals.map(e => {
        const start = e.startTime * 1000;
        const end = e.endTime * 1000;
        const intervalDateTimeFormat = DATETIME_FORMAT_IN_ISO;
        return {
          start,
          end,
          label: `${moment(start).format(intervalDateTimeFormat)} - ${moment(end).format(intervalDateTimeFormat)}`,
          width: `${this.getScanIntervalWidth(start, end)}%`,
          blank: false
        };
      }, this);

      // intervals
      const dvrScanIntervalsResult = [];
      let intervalAux = props.dvrScanRequested.start;
      dvrScanIntervals.forEach(e => {
        if (intervalAux < e.start) {
          dvrScanIntervalsResult.push({
            start: intervalAux,
            end: e.start,
            width: `${this.getScanIntervalWidth(intervalAux, e.start)}%`,
            blank: true
          });
        }
        intervalAux = e.end;
        dvrScanIntervalsResult.push(e);
      });
      this.setState({
        dvrScanIntervals: dvrScanIntervalsResult,
        dvrScanTimeLabels
      });
    } else {
      this.setState({
        dvrScanIntervals: [],
        dvrScanTimeLabels
      });
    }
  }

  formatDuration = total => {
    const minutes = parseInt(total / 60, 0);
    const seconds = total % 60;

    const minStr = (minutes > 0) ? `${minutes} ${I18n.t('page.onDemand.requestQueue.minute')} ` : '';
    const secStr = (seconds > 0) ? `${seconds} ${I18n.t('page.onDemand.requestQueue.second')}` : '';

    return minStr + secStr;
  }

  openPlayer = media => () => {
    const query = {mediaId: media.id};

    if (systemId && systemId === 'geotab') {
      this.props.history.push(`/player?${querystring.stringify(query)}`);
    } else {
      this.props.push(`/player?${querystring.stringify(query)}`);
    }
  }

  renderSortHeader = (sort, translationKey) => {
    const {previouslyRequestedQueue: queue} = this.props;
    return (
      <div className={queue.sort === sort ? 'table__sortcont table__sortcont-sorted' : 'table__sortcont'} onClick={this.handleSortTable(sort)}>
        {I18n.t(`page.onDemand.requestQueue.${translationKey}`)}
        {this.renderSortIcon(sort)}
      </div>
    );
  }

  renderSortIcon = sort => {
    const {previouslyRequestedQueue: queue} = this.props;

    let iconClass = 'sortupward';
    let iconName = 'arrow_downward';

    if (queue.sort === sort && queue.sortOrder === 'asc') {
      iconClass = 'sortdownward';
      iconName = 'arrow_downward';
    }

    return (
      <Icon className={`table__arrow ${iconClass}`}>{iconName}</Icon>
    );
  }

  renderQueueEmpty() {
    const {requestQueue} = this.props;
    if (!requestQueue.isLoading && requestQueue.list.length <= 0) {
      return (
        <TableRow>
          <TableCell>
            <span className="ondemand__infomsg"><Icon className="ondemand__msgicon">info</Icon>{I18n.t('page.onDemand.requestQueue.listEmpty')}</span>
          </TableCell>
        </TableRow>
      );
    }

    return null;
  }

  renderActionButtonFor = e => {
    const statusLower = toLower(e.status);
    const toCancelList = ['reopened', 'created'];

    if (toCancelList.includes(statusLower)) {
      const disabled = this.props.isInternalUser;

      return (
        <IconButton
          onClick={this.handleCancelMedia(e)}
          disabled={disabled}
          title={disabled && I18n.t('defaults.noPermissionFunctionality')}
        >
          <Icon>delete</Icon>
        </IconButton>
      );
    } else if (statusLower === 'completed') {
      return (
        <IconButton onClick={this.openPlayer(e)}>
          <Icon className="play-icon testclass">play_circle_filled</Icon>
        </IconButton>
      );
    }

    return null;
  }

  renderQueueItem = (e, i) => {
    const statusLower = toLower(e.status);

    const tblClasses = classNames({
      table__success: (statusLower === 'completed'),
      table__error: (statusLower === 'expired' || statusLower === 'notavailable' || statusLower === 'failed')
    });

    let status = I18n.t(`page.onDemand.requestQueue.statuses.${statusLower}`);
    if (statusLower === 'created' || statusLower === 'reopened') {
      status = I18n.t('page.onDemand.requestQueue.statuses.requested');
    } else if (statusLower === 'waiting') {
      status = I18n.t('page.onDemand.requestQueue.statuses.processed');
    }

    return (
      <TableRow className={tblClasses} key={i}>
        <TableCell className="ondemand__actionscell">{this.renderActionButtonFor(e)}</TableCell>
        <TableCell className={`${tblClasses}-cell ondemand__statuscell`}>{status}</TableCell>
        <TableCell className="ondemand__vehiclecell">{e.vehicleNumber}</TableCell>
        <TableCell className="ondemand__whocell">{this.getUsername(e)}</TableCell>
        <TableCell className="ondemand__datetimecell">{moment(e.requestDate).format(I18n.t('configuration.fullDateTimeFormat'))}</TableCell>
        <TableCell className="ondemand__durationcell">{this.formatDuration(e.durationSeconds)}</TableCell>
        <TableCell className="ondemand__datetimecell">{moment(e.startDate).format(I18n.t('configuration.fullDateTimeFormat'))}</TableCell>
        <TableCell className="ondemand__smallcamicons ondemand__viewscell">
          <CameraViews channels={e.channels} machineType={get(e, 'metadata.machineType', 0)} renderIcons={false} sortCameraViews={true}/>
        </TableCell>
      </TableRow>
    );
  }

  isClearEnabled = () => {
    const {
      dvr,
      startDate,
      startTime,
      duration
    } = this.state;

    return !!startDate || !!startTime || !!duration || !!dvr;
  }

  onDatePickerError = (reason, value) => {
    this.setState({dateError: reason}, this.validateForm);
  }

  onStartTimePickerError = (reason, value) => {
    this.setState({starTimeError: reason}, this.validateForm)
  }

  onDurationError = (reason, value) => {
    this.setState({durationError: reason}, this.validateForm)
  }

  getDurationError = (textFieldParams) => {
    const { durationInvalid, durationInFuture, durationError} = this.state;

    if (durationError === 'invalidDate') {
      return textFieldParams?.inputProps?.placeholder;
    }

    if (durationInvalid) {
      return I18n.t('page.onDemand.form.videoTooLongError')
    }
    if (durationInFuture) {
      return I18n.t('page.onDemand.form.videoInFutureError');
    }
    return '';
  }

  getStartDateError = (textFieldParams) => {
    const { dateError } = this.state;
    if (dateError === 'minDate' || dateError === 'disableFuture') {
      return I18n.t('filter.date.error.within180days')
    }
    if (dateError === 'invalidDate') {
      return textFieldParams?.inputProps?.placeholder;
    }
  }

  onDurationBlur =  event => {
    const durStr = "0000";

    let dur = event.target.value;
    if (dur.indexOf(":") >= 0) {
      dur = parseInt(dur.replace(":", "")).toString();
    }
    let out = durStr.slice(dur.length) + dur;
    out = out.slice(0, 2) + ":" + out.slice(2);

    this.setState({
      duration:  moment(out, "mm:ss")
    }, this.validateForm);
  }

  render() {
    const {requestQueue, previouslyRequestedQueue, machineType} = this.props;
    const camType = MACHINE_TYPE.get(machineType);
    const {
      step,
      vehicle,
      dvr,
      workflow,
      startDateTime,
      endDateTime,
      cameras,
      duration,
      durationTotal,
      tabIndex,
      dateError,
      blurringField
    } = this.state;

    const isQueueTab = (tabIndex === 0);
    const isPreviouslyTab = (tabIndex === 1);

    const cameraOptions = {
      order: this.props.channelsAvailable,
      machineType,
      cameras: cameras
    };

    const customerWifi = get(this.props, 'customer.data.onDemand.wifi.enabled', false);
    const hasWifi = get(this.props, 'hasWifi', false);
    const wifiCheckEnabled = customerWifi && hasWifi;

    const onDemandParent = systemId === 'geotab' ? 'ondemand__parent geotabOnDemand' : 'ondemand__parent';
    const onDemandParentEmpty = systemId === 'geotab' ? 'ondemand__parent__empty geotabOnDemand' : 'ondemand__parent__empty';
    /* eslint-disable max-len */
    return (
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <div>
          {systemId != 'geotab' &&
            <ScrollEvent handleScrollCallback={this.handleLazyLoading} />
          }
          {systemId === 'geotab' &&
            <ScrollEvent handleScrollCallback={this.handleLazyLoadingGeotab} />
          }
          {!this.props.isLoadingRequest && (
            <Grid container>
              <Grid item lg={5} md={5} sm={12} xs={12}>
                <Grid item className={step === 1 ? 'ondemand' : 'hideme'}>
                  <Card>
                    <CardHeader title={I18n.t('page.onDemand.form.title')} />
                    <CardContent>
                      <List>
                        {workflow === 'dvr' &&
                          <ListItem className="ondemand__listitem-first ondemand-zindex">
                            <FormControl error aria-describedby="error-text" className="ondemand__field">
                              <AutoCompleteInput
                                id="serialNumber"
                                label={I18n.t('page.onDemand.form.serialVehicleNumber')}
                                list={this.props.dvrList}
                                keepValueSelected
                                onSelect={this.handleOnSelectedDvrAutocomplete}
                                onFetchRequested={this.handleOnFetchDvrAutocomplete}
                                isLoading={this.props.isLoading}
                                value={this.state.serialAutocompleteValue}
                                onChange={this.handleSerialAutocompleteChange}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <Tooltip title={I18n.t('page.onDemand.form.serialVehicleNumberInfo')}>
                                      <Icon>info</Icon>
                                    </Tooltip>
                                  </InputAdornment>
                                }
                              />
                              {this.state.dvrInvalid && <FormHelperText id="error-text"><span>{I18n.t('page.onDemand.form.serialVehicleNumberMissing')}</span></FormHelperText>}
                            </FormControl>
                          </ListItem>
                        }
                        {workflow === 'vehicle' &&
                          <ListItem className="ondemand__listitem-first ondemand-zindex">
                            <FormControl error aria-describedby="error-text" className="ondemand__field">
                              <AutoCompleteInput
                                id="vehicleNumber"
                                label={I18n.t('page.onDemand.form.vehicleNumber')}
                                list={this.props.vehiclesList}
                                keepValueSelected
                                onSelect={this.handleOnSelectedAutocomplete}
                                onFetchRequested={this.handleOnFetchAutocomplete}
                                isLoading={this.props.isLoading}
                                value={this.state.autocompleteValue}
                                onChange={this.handleAutocompleteChange}
                              />
                              {this.state.vehicleInvalid && <FormHelperText id="error-text"><span>{I18n.t('page.onDemand.form.vehicleNumberMissing')}</span></FormHelperText>}
                            </FormControl>
                          </ListItem>
                        }
                        <ListItem className="ondemand__listitem">
                          <FormControl error aria-describedby="error-text" className="ondemand__field">
                            <ChannelsAvailable
                              options={cameraOptions}
                              onChange={this.handleOnChangeCamera}
                              isLoading={this.props.isLoading}
                            />
                            {this.props.channelsNotFound && <FormHelperText id="error-text"><span>{I18n.t('page.onDemand.form.camerasNotFound')}</span></FormHelperText>}
                          </FormControl>
                        </ListItem>
                        <ListItem style={{ alignItems: 'baseline'}} className={systemId === 'geotab' ? 'ondemand__listitem-date' : ''} >
                          <DatePicker
                            PopperProps={{placement:'bottom-start'}}
                            label={I18n.t('page.onDemand.form.date')}
                            inputFormat="yyyy-MM-DD"
                            value={this.state.startDate || null}
                            onChange={this.handleOnChangeDate}
                            renderInput={(params) => <TextField {...params}
                              helperText={this.getStartDateError(params) || params?.inputProps?.placeholder}
                              />}
                            InputLabel="yyyy-MM-DD"
                            mask="____-__-__"
                            OpenPickerButtonProps={{tabIndex: '-1'}}
                            disableFuture={true}
                            minDate={moment().startOf('day').subtract(180, 'days')}
                            onError={this.onDatePickerError}
                          />
                          <TimePicker
                            ampm={false}
                            openTo="hours"
                            views={['hours', 'minutes', 'seconds']}
                            inputFormat="HH:mm:ss"
                            mask="__:__:__"
                            label={I18n.t('page.onDemand.form.time')}
                            value={this.state.startTime || null}
                            onChange={this.handleOnChangeStartTime}
                            renderInput={(params) => <TextField {...params}
                              helperText={this.state.durationInFuture ? I18n.t('page.onDemand.form.videoInFutureError') : params?.inputProps?.placeholder}
                              error={this.state.durationInFuture}
                              />}
                            PopperProps={{placement:'bottom-start'}}
                            OpenPickerButtonProps={{tabIndex: '-1'}}
                            style={{ marginTop: "20px" }}
                            className="ondemand__time"
                            onError={this.onStartTimePickerError}
                          />
                          <TimePicker
                            ampm={false}
                            openTo="minutes"
                            views={['minutes', 'seconds']}
                            inputFormat="mm:ss"
                            mask="__:__"
                            label={I18n.t('page.onDemand.form.duration')}
                            value={duration}
                            onChange={this.handleOnChangeDuration}
                            renderInput={(params) => <TextField {...params}
                              helperText={this.getDurationError(params) || params?.inputProps?.placeholder}
                              error={!!this.getDurationError(params)}
                              onBlur={this.onDurationBlur}/>}
                            className="ondemand__durationcont"
                            PopperProps={{placement:'bottom-start'}}
                            OpenPickerButtonProps={{tabIndex: '-1'}}
                            onError={this.onDurationError}
                            disableIgnoringDatePartForTimeValidation={true}
                            maxTime={moment().hour(0).minute(0).second(0).milliseconds(999).add({ minutes: MAX_DURATION_MIN })}
                          />
                        </ListItem>
                        <ListItem className="availablevideo">
                          {this.props.dvrScanVisible && <label className="availablevideo__label">{I18n.t('page.onDemand.form.videoAvailability.label')}</label>}
                          {this.props.dvrScanVisible &&
                            <div className="availablevideo__cont">
                              <div className="availablevideo__timerangecont">
                                {this.state.dvrScanIntervals.map((item, index) => {
                                  if (!item.blank) {
                                    return (<div key={`dvrScanInterval-${index}`} className="availablevideo__timerange" title={item.label} style={{ width: item.width }} />);
                                  }
                                  return (<div key={`dvrScanInterval-${index}`} className="availablevideo__timerange-blank" title={item.label} style={{ width: item.width }} />);
                                })}
                              </div>
                              <div className="availablevideo__markercont">
                                {this.state.dvrScanTimeLabels.map((item, index) => {
                                  return (
                                    <div key={`dvrScanInterval-${index}`} className="availablevideo__marker">
                                      <span className="availablevideo__time">{item}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          }
                          {this.props.dvrScanErrorMessage &&
                            <p className="availablevideo__feedback">
                              <Icon className="availablevideo__feebackicon">videocam_off</Icon>
                              {I18n.t('page.onDemand.form.videoAvailability.error')}
                            </p>
                          }
                          {(this.props.dvrScanStatus === false && this.props.dvrScanErrorMessage === false) &&
                            <p className="availablevideo__feedback">
                              <Icon className="availablevideo__feebackicon">videocam_off</Icon>
                              {I18n.t('page.onDemand.form.videoAvailability.missing')}
                            </p>
                          }
                          <Button
                            id="checkVideoAvailabilityButton"
                            disabled={this.state.submitDisabled}
                            onClick={this.handleOnCheckAvailability}
                            variant="contained"
                            color="default"
                            className="btn btn-terciery"
                          >
                            {this.props.dvrScanLoading &&
                              <CircularProgress className="availablevideo__loading" />
                            }
                            {!this.props.dvrScanLoading &&
                              <Icon className="availablevideo__cameicon">videocam</Icon>
                            }
                            {I18n.t('page.onDemand.form.videoAvailability.button')}
                          </Button>
                          <div className="col-md-12" />
                        </ListItem>
                      </List>
                    </CardContent>
                    <CardActions className="ondemand__actions">
                      {this.state.blurringField && this.state.blurringField.show && 
                        <BlurringSettings
                          options={this.state.blurringField}
                          onChange={this.handleOnChangeBlurring}
                          isLoading={this.props.isLoading}
                          disabled={this.state.blurringField.disabled}
                            />
                      }
                      <label className={!wifiCheckEnabled && 'hideme'}>
                        {I18n.t('page.onDemand.form.wifi')}
                        <Checkbox
                          id="wifiUpload"
                          disabled={!wifiCheckEnabled}
                          checked={this.props.wifiEnabled}
                          onChange={this.handleChangeWifi}
                        />
                      </label>
                      <Button
                        id="onClearSubmit"
                        onClick={this.handleOnClear}
                        disabled={!this.isClearEnabled()}
                        variant="contained"
                        color="default"
                        className="btn btn-secondary">{I18n.t('page.onDemand.form.clear')}</Button>
                      <Button id="onDemandSubmit" disabled={this.state.submitDisabled} onClick={this.handleOnConfirmation} variant="contained" color="primary" className="btn btn-primary">{I18n.t('page.onDemand.form.submit')}</Button>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid item className={!this.props.fetchSuccess && step === 2 ? 'ondemand' : 'hideme'}>
                  <Card>
                    <CardHeader title={I18n.t('page.onDemand.confirmation.title')} />
                    <CardContent>
                      <List>
                        <ListItem className="ondemand__row">
                          <Grid item md={6}>
                            {workflow === 'dvr' && I18n.t('page.onDemand.form.serialVehicleNumber')}
                            {workflow === 'vehicle' && I18n.t('page.onDemand.form.vehicleNumber')}
                          </Grid>
                          <Grid item md={6}>
                            {workflow === 'dvr' && dvr && dvr.name}
                            {workflow === 'vehicle' && vehicle && vehicle.name}
                          </Grid>
                        </ListItem>
                        <ListItem className="ondemand__row">
                          <Grid item md={6}>
                            {I18n.t('page.onDemand.form.date')}
                          </Grid>
                          <Grid item md={6}>
                            {(!!startDateTime) ? startDateTime.format(I18n.t('configuration.dateFormat')) : ''}
                            {
                              (!!startDateTime) && (startDateTime.day() !== endDateTime.day()) && (
                                ` - ${endDateTime.format(I18n.t('configuration.dateFormat'))}`
                              )
                            }
                          </Grid>
                        </ListItem>
                        <ListItem className="ondemand__row">
                          <Grid item md={6}>
                            {I18n.t('page.onDemand.form.time')}
                          </Grid>
                          <Grid item md={6}>
                            {(!!startDateTime) && startDateTime.format(I18n.t('configuration.timeFormat'))} - {endDateTime.format(I18n.t('configuration.timeFormat'))}
                          </Grid>
                        </ListItem>
                        <ListItem className="ondemand__row">
                          <Grid item md={6}>
                            {I18n.t('page.onDemand.form.duration')}
                          </Grid>
                          <Grid item md={6}>
                            {!!duration && duration.isValid() && duration.format('mm:ss')}
                          </Grid>
                        </ListItem>
                        {(blurringField && blurringField.show && blurringField.value === true) &&
                          <ListItem className="ondemand__row">
                            <Grid item md={6}>
                              {I18n.t('page.onDemand.confirmation.selectedBlurringOption')}
                            </Grid>
                            <Grid item md={6}>
                              {blurringField.value ? 'Blurring Selected': 'false'}
                            </Grid>
                          </ListItem>
                        }
                        <ListItem className="ondemand__row">
                          <Grid item md={6}>
                            {I18n.t('page.onDemand.confirmation.selectedCameras')}
                          </Grid>
                          <Grid item md={6} className="ondemand__selectedviews-cont">
                            {cameras.map((camera) => {
                              return (
                                <label>
                                  <div className={`ondemand__cameraviews ${camera.key}-cam`}>
                                    <Icon className="videothumb__camview">{`arrow_${camera.arrowDirection}`}</Icon>{I18n.t(`page.onDemand.form.camera.${camera.key}`)}
                                  </div>
                                </label>
                              )
                            })}
                          </Grid>
                        </ListItem>
                        <ListItem className="ondemand__row ondemand__totalcharges">
                          <Grid item md={6}>
                            {I18n.t('page.onDemand.confirmation.totalMinutes')}
                          </Grid>
                          <Grid item md={6}>
                            {durationTotal}
                          </Grid>
                        </ListItem>
                        <ListItem className="ondemand__inforow">
                          <Grid item md={12} className="ondemand__info">
                            <Icon className="ondemand__info-icon">info</Icon><span>{I18n.t('page.onDemand.chargeWarning')}</span>
                          </Grid>
                        </ListItem>
                        {this.props.requestedSeconds != null && (
                          <ListItem className="ondemand__info">
                            <Icon className="ondemand__timeicon">access_time</Icon>
                            <label>
                              <Translate
                                value="page.onDemand.confirmation.totalMinutesRequested"
                                dangerousHTML
                                count={Math.round(this.props.requestedSeconds / 60)}
                              />
                            </label>
                          </ListItem>
                        )}
                      </List>
                    </CardContent>
                    <CardActions className="ondemand__actions">
                      <Button id="onDemandCancel" onClick={this.handleOnCancel} variant="contained" color="default" className="btn btn-secondary">{I18n.t('page.onDemand.form.cancel')}</Button>
                      <Button id="onDemandConfirm" disabled={this.props.isInternalUser} onClick={this.handleOnSubmit} variant="contained" color="primary" className="btn btn-primary">{I18n.t('page.onDemand.form.confirm')}</Button>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid item className={this.props.fetchSuccess && step === 2 ? 'ondemand' : 'hideme'}>
                  <Card>
                    <CardContent>
                      <ListItem className="ondemand__centerrow">
                        <Icon className="ondemand__successiconrow">check_circle</Icon>
                      </ListItem>
                      <List>
                        <ListItem className="ondemand__centerrow">
                          {I18n.t('page.onDemand.successMessage')}
                        </ListItem>
                      </List>
                    </CardContent>
                    <CardActions className="ondemand__actions-centered">
                      <Button id="onDemandBlankequest" onClick={this.resetToBlankForm} variant="contained" color="primary" className="btn-primary">{I18n.t('page.onDemand.newRequest')}</Button>
                      <Button id="onDemandRequestAnother" onClick={this.resetKeepingRequestParams} variant="contained" color="default" className="btn-secondary">{I18n.t('page.onDemand.requestAnother')}</Button>
                      <Button id="onDemandGoToLibrary" onClick={this.handleGoToLibrary} variant="contained" color="primary" className="btn-primary">{I18n.t('page.onDemand.goToLibrary')}</Button>
                    </CardActions>
                  </Card>
                </Grid>
              </Grid>
              <Grid item lg={7} md={7} sm={12} xs={12} className={(isQueueTab && requestQueue.list.length > 0) || (isPreviouslyTab && previouslyRequestedQueue.list.length > 0) ? onDemandParent : onDemandParentEmpty}>
                <div className="ondemand__tabs-cont">
                  <AppBar position="static" color="default">
                    <Tabs
                      value={tabIndex}
                      onChange={this.handleChangeTab}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="fullWidth"
                    >
                      <Tab label={I18n.t('page.onDemand.tabs.requestQueue')} id="requestQueueTab" />
                      <Tab label={I18n.t('page.onDemand.tabs.previouslyRequested')} id="previouslyRequestedTab" />
                    </Tabs>
                  </AppBar>
                  <DesktopOnDemandFilter
                    onChange={this.handleOnDemandFilter}
                    onDemandFilter={this.state.onDemandFilter}
                    tabIndex={this.state.tabIndex}
                    showInCabinCamera={this.state.totalAdPlusDvrs > 0 ? 'true' : 'false'}
                  />
                  {((isQueueTab && requestQueue.list.length > 0) || (isPreviouslyTab && previouslyRequestedQueue.list.length > 0)) && (
                    <Table className="table__contnh ondemand__tableheader">
                      <TableHead>
                        <TableRow className="table__head">
                          <TableCell className="ondemand__actionscell">&nbsp;</TableCell>
                          <TableCell className="ondemand__statuscell">{I18n.t('page.onDemand.requestQueue.status')}</TableCell>
                          <TableCell className="ondemand__vehiclecell">{I18n.t('page.onDemand.requestQueue.vehicleNumber')}</TableCell>
                          <TableCell className="ondemand__whocell">{I18n.t('page.onDemand.requestQueue.whoRequested')}</TableCell>
                          <TableCell className="ondemand__datetimecell">
                            {isPreviouslyTab && this.renderSortHeader('requestDate', 'dateTimeRequested')}
                            {isQueueTab && (
                              <React.Fragment>
                                {I18n.t('page.onDemand.requestQueue.dateTimeRequested')}
                              </React.Fragment>
                            )}
                          </TableCell>
                          <TableCell className="ondemand__durationcell">
                            {isPreviouslyTab && this.renderSortHeader('durationSeconds', 'durationRequested')}
                            {isQueueTab && (
                              <React.Fragment>
                                {I18n.t('page.onDemand.requestQueue.durationRequested')}
                              </React.Fragment>
                            )}
                          </TableCell>
                          <TableCell className="ondemand__datetimecell">
                            {isPreviouslyTab && this.renderSortHeader('startDate', 'videoStartTime')}
                            {isQueueTab && (
                              <React.Fragment>
                                {I18n.t('page.onDemand.requestQueue.videoStartTime')}
                              </React.Fragment>
                            )}
                          </TableCell>
                          <TableCell className="ondemand__viewscell">{I18n.t('page.onDemand.requestQueue.cameraViewsRequested')}</TableCell>
                        </TableRow>
                      </TableHead>
                    </Table>
                  )}
                </div>

                <SwipeableViews
                  index={tabIndex}
                  onChangeIndex={this.handleChangeTabIndex}
                >
                  <div style={{ marginTop: '50px' }}>
                    <TabContainer>
                      <ProgressSpinner show={requestQueue.isLoading} />

                      <Table className="table__contnh">
                        <TableBody>
                          {this.renderQueueEmpty()}

                          {
                            requestQueue.list.map((e, i) => (
                              this.renderQueueItem(e, i)
                            ))
                          }
                        </TableBody>
                      </Table>
                    </TabContainer>
                  </div>
                  <TabContainer>
                    <PreviouslyQueue
                      isEnabled={isPreviouslyTab}
                      isLoading={previouslyRequestedQueue.isLoading}
                      canChangeStatus={!this.props.isInternalUser}
                      onDemandFilter={this.state.onDemandFilter}
                    />
                  </TabContainer>
                </SwipeableViews>
              </Grid>
            </Grid>
          )}
        </div>
      </LocalizationProvider>
    );
  }
}

export default withRouter(DesktopOnDemand);
